import { Injectable } from '@angular/core'
import { ThemeEnum } from '@modules/theme-module/enums/theme.enum'
import { BehaviorSubject } from 'rxjs'
import { KeyThemeLocalstorage } from '@modules/theme-module/constants/key-theme-local-storage'

@Injectable({
	providedIn: 'root',
})
export class ThemeService {
	protected readonly themeEnum: typeof ThemeEnum = ThemeEnum
	protected readonly keyThemeLocalstorage: string = KeyThemeLocalstorage

	public theme$: BehaviorSubject<ThemeEnum> = new BehaviorSubject<ThemeEnum>(this.themeEnum.LIGHT)

	private _setThemeLocalStorage(): void {
		localStorage.setItem(this.keyThemeLocalstorage, JSON.stringify(this.theme$.getValue()))
	}

	private _getThemeLocalStorage(): ThemeEnum | null {
		return JSON.parse(localStorage.getItem(this.keyThemeLocalstorage) || 'null')
	}

	private _getSystemTheme(): ThemeEnum {
		const isSystemDarkMode: boolean = window.matchMedia('(prefers-color-scheme: dark)').matches

		return isSystemDarkMode ? this.themeEnum.DARK : this.themeEnum.LIGHT
	}

	public initTheme(): void {
		this.theme$.next(this._getThemeLocalStorage() ?? this._getSystemTheme())
		this._setThemeLocalStorage()
	}

	public toggleTheme(theme?: ThemeEnum): void {
		const totalTheme: ThemeEnum = theme
			? theme
			: this.theme$.getValue() === this.themeEnum.LIGHT
				? this.themeEnum.DARK
				: this.themeEnum.LIGHT

		this.theme$.next(totalTheme)
		this._setThemeLocalStorage()
	}
}
